module.exports = __webpack_public_path__ + "static/Illu_Team-a20c2e7cbbd904b11377029b19de975a.svg";